/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1PersonIdTeacherThumbnail202,
  PostApiV1PersonIdTeacherThumbnail400,
  PostApiV1PersonIdTeacherThumbnail401,
  PostApiV1PersonIdTeacherThumbnail404,
  PostApiV1PersonIdTeacherThumbnail500,
  PostApiV1PersonIdTeacherThumbnailMutationRequest,
  PostApiV1PersonIdTeacherThumbnailMutationResponse,
  PostApiV1PersonIdTeacherThumbnailPathParams,
} from "../../types/personTeacherController/PostApiV1PersonIdTeacherThumbnail.ts";

export const postApiV1PersonIdTeacherThumbnailPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1PersonIdTeacherThumbnailPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1PersonIdTeacherThumbnail202Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdTeacherThumbnail202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1PersonIdTeacherThumbnail400Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdTeacherThumbnail400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1PersonIdTeacherThumbnail401Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdTeacherThumbnail401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1PersonIdTeacherThumbnail404Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdTeacherThumbnail404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1PersonIdTeacherThumbnail500Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdTeacherThumbnail500>;

export const postApiV1PersonIdTeacherThumbnailMutationRequestSchema = z.object({
  file: z.optional(z.instanceof(File)),
}) as unknown as ToZod<PostApiV1PersonIdTeacherThumbnailMutationRequest>;

export const postApiV1PersonIdTeacherThumbnailMutationResponseSchema = z.lazy(
  () => postApiV1PersonIdTeacherThumbnail202Schema,
) as unknown as ToZod<PostApiV1PersonIdTeacherThumbnailMutationResponse>;
